module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/recommend_spot_dummy-5148c6b5498b209c26282cc4dc0bd7e2.jpg";